import styled from 'styled-components';

interface ButtonProps {
  hover?: boolean;
}

export const ContactsButton = styled.button`
  min-width: 100px;
  padding: 0 24px;
  height: 40px;
  border-radius: 4px;
  box-shadow: ${(props: ButtonProps) => props.hover ? '2px 2px 4px 0 rgba(54, 123, 245, 0.24), 4px 4px 8px 0 rgba(54, 123, 245, 0.16)' : '0 2px 4px 0 rgba(54, 123, 245, 0.24), 0 4px 8px 0 rgba(54, 123, 245, 0.16)'};
  border: solid 0.5px #0183c4;
  background-color: #009bdf;
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  cursor: pointer;
  margin: 0 0.5rem;

  &:disabled, &[disabled] {
    background-color: #ccc;
    border: black;
    cursor: not-allowed;
  }
`;

export const ContactsButtonSecondary = styled(ContactsButton)`
  color: #009bdf;
  border-radius: 4px;
  box-shadow: ${(props: ButtonProps) => props.hover ? 'none' : '1px 1px 4px 0 rgba(54, 123, 245, 0.14), 2px 2px 8px 0 rgba(54, 123, 245, 0.06)'};
  border: solid 1px #009bdf;
  background-color: #fff;
`;
